import instance from "api/apiClient";
import { apiRoutes } from "configs/apiRoutes";

export interface PlayerFinancialSummary {
  balances: { real: string; bonus: string; hold: string; currency: string };
  statistics: { totalDeposits: string; totalWithdrawals: string };
  profitability: {
    result: string;
    status: "profitable" | "unprofitable" | "neutral";
    realGgr: string | null;
    realGgrCurrency: string;
    realGgrAvailable: boolean;
  };
}

export async function getPlayerFinancialSummary(
  userId: number,
  signal?: AbortSignal,
) {
  const response = await instance.get<{ data: PlayerFinancialSummary }>(
    `${apiRoutes.playerFinancialSummary}/${userId}`,
    { signal },
  );
  // The shared client already unwraps the Axios response.
  return response.data as unknown as PlayerFinancialSummary;
}
